//@flow
import React from 'react'
import iconCar from './images/icon-car.svg'
import iconEcar from './images/icon-ecar.svg'
import iconBus from './images/icon-bus.svg'
import iconTrain from './images/icon-train.svg'
import iconPlane from './images/icon-plane.svg'
import { Car } from './images/car'
import { Ecar } from './images/ecar'
import { Bus } from './images/bus'
import { Train } from './images/train'
import { Plane } from './images/plane'
import { Waypoint } from 'react-waypoint'
import { Spring } from 'react-spring/renderprops.cjs'
import dummyAnimation from './images/icon-route.svg'
import Lottie from 'react-lottie'
import animationRoute from './images/animation-route.json'
import animationRouteDark from './images/animation-route-dark.json'
import './styles.scss'

let icons = {}

const animationDuration = 2000
const animationLightOptions = {
  animationData: animationRoute,
  loop: false,
  autoplay: false,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}
const animationDarkOptions = {
  animationData: animationRouteDark,
  loop: false,
  autoplay: false,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

function numberWithApostroph(x) {
  let num = x.toString()
  if(num.length > 4) {
    num = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  }
  return num;
}


export class Card extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      play: false
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    icons = { 
      Auto: <Car fill={this.props.colorMode === 'dark' ? '#fff' : '#202346'} />,
      "E-Auto": <Ecar fill={this.props.colorMode === 'dark' ? '#fff' : '#202346'} />,
      Car: <Bus fill={this.props.colorMode === 'dark' ? '#fff' : '#202346'} />,
      Zug: <Train fill={this.props.colorMode === 'dark' ? '#fff' : '#202346'} />,
      Flugzeug: <Plane fill={this.props.colorMode === 'dark' ? '#fff' : '#202346'} />
    }
    return <div className='card'>
              <Spring
                  from={{kg: 0, percentage: 0, km: 0}}
                  to={{
                    kg: this.state.play ? this.props.kg : 0,
                    percentage: this.state.play ? this.props.percentage : 0,
                    km: this.state.play ? this.props.km : 0
                  }}
                  config={{
                    duration: animationDuration
                  }}
                >
                  {props => (
                    <>
                        <div className="top">
                          <div className="title">
                           {icons[this.props.vehicle]}
                            <h3>{this.props.title}</h3>
                          </div>
                          <div className="stats">
                            <ul>
                              <li><span className="cat">Typ: </span>{this.props.type}</li>
                              <li><span className="cat">Treibstoff: </span>{this.props.drive}</li> 
                              <li><span className="cat">Passagiere: </span>{this.props.passengers} Personen</li> 
                            </ul>
                          </div>
                          
                          <div className="emission">
                            <div className='count'><span className='value'>{Math.round(props.kg)}</span> kg CO<sub>2</sub>e</div>
                            <div className='label'>CO<sub>2</sub>-Äquivalente pro Person</div>
                            <div className='chart'>
                              <div className='bar' style={{width: Math.round(props.percentage) + '%'}} />
                            </div>
                          </div>
                        </div>
                        <Waypoint
                          scrollableAncestor={window}
                          onEnter={event => {
                            this.setState({ play: true })
                          }}
                          onLeave={event => {
                            // this.setState({ play: false })
                          }}
                        >
                        <div className="bottom">
                        <div className="animation">
                            <div className="wrapper">
                                <Lottie
                                  isStopped={!this.state.play}
                                  options={this.props.colorMode === 'dark' ? animationDarkOptions : animationLightOptions}
                                />

                                {/* <img className='icon' src={dummyAnimation} alt='dummy' /> */}
                            </div>
                            <div className="labels">
                              <div className="start">{this.props.start}</div>
                              <div className="end">{this.props.end}</div>
                            </div>
                          </div>
                          <div className="spacer" />
                          <div className="distance">
                            <div className='count'><span className='value'>{Math.round(props.km)}</span> km</div>
                            <div className='label'>Hin- und Rückfahrt</div>
                            <div className='duration'>{this.props.duration}</div>
                          </div>
                        </div>
                      </Waypoint>
                    </>
               )}
              </Spring>
    </div>
  }
}



             